import PlayerWrapper from "./PlayerWrapper";

export default PlayerWrapper;
